import styled, { css } from "styled-components";

const semanticTokens = {
  padding: {
    paddingTop: "3rem",
    paddingBottom: "3.4rem",
    get paddingLeft() {
      return semanticTokens.padding.paddingTop;
    },
    get paddingRight() {
      return semanticTokens.padding.paddingTop;
    },
  },

  day: {
    width: "3.6rem",
    height: "3.6rem",
  },
};

export const Wrap = styled.div`
  background: ${({ theme }) => theme.color.background.white};
  ${semanticTokens.padding}
  border-radius: 1rem;
  box-sizing: border-box;
  box-shadow: 0 0.4rem 1rem rgba(0, 0, 0, 0.1);

  display: inline-flex;
  flex-direction: column;
  gap: 2.4rem;

  ${({ theme }) => css`
    border: 0.1rem solid ${theme.color.stroke.light};
  `}
`;

export const CalendarHeader = styled.header`
  display: flex;
  align-items: center;
`;
export const YearMonth = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;

  ${({ theme }) => css`
    color: ${theme.color.text.default};
    ${theme.typography.body1.semibold}
  `}
`;

export const CalendarBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.3rem;
`;
export const DateList = styled.ul`
  display: grid;
  grid-template-columns: repeat(7, auto);
  grid-auto-rows: ${semanticTokens.day.height};
  justify-items: center;
  align-items: center;
  row-gap: 1.2rem;
`;

export const DaysOfWeekWrap = styled.ul`
  list-style: none;

  display: grid;
  grid-template-columns: repeat(7, 1fr);
`;

export const Day = styled.li`
  width: ${semanticTokens.day.width};
  height: ${semanticTokens.day.height};

  display: flex;
  justify-content: center;
  align-items: center;
`;
